import SidebarItem from "./sidebarItem";
import { getSidebarData } from "./sidebarData";
import { useAuth } from "../../context/AuthContext";
import acu_logo from "../../assets/images/acumenVelocityLogo.svg";
import "./sidebar.css";
import { useEffect, useState } from "react";

const getInitialTab = () => {
    const storedTab = localStorage.getItem("active_tab");
    return storedTab || "Overview";
};

export default function Sidebar() {
    const { isAdmin, isTeamLead } = useAuth();
    const data = getSidebarData(isAdmin, isTeamLead);
    const [activeTab, setActiveTab] = useState(getInitialTab());
    useEffect(() => {
        if (activeTab) {
            localStorage.setItem("active_tab", activeTab);
        }
    }, [activeTab]);

    return (
        <div className="sidebar d-flex flex-column bg-white border-end">
            <div className="flex-grow-1 border-end w-100" style={{ height: '92vh', maxWidth: '20rem' }}>
                <div className="translation border-bottom d-flex px-2 mt-2" >
                    <img src={acu_logo} className="tranlation_logo img-fluid me-2" alt="Logo" />
                    <h6 className="m-0 d-none d-md-block text-start fs_md_12 ">Acumen Translation Hub</h6>
                </div>
                {data.map((item, index) => (
                    <SidebarItem key={index} item={item} activeTab={activeTab} setActiveTab={setActiveTab} />
                ))}
            </div>
        </div>
    );
}
